export const DEFAULT_COLUMN_PRESET_STATE = {
      'landings': {
        'width': {
          'landings-name': 300
        },
        'columns': ['landings-name'],
        'order': {
          'orderBy': 'landings-name',
          'orderDir': 'desc'
        },
        'context': 'landings',
        'totalType': {}
      },
      'offers': {
        'width': {
          'offers-name': 300
        },
        'columns': ['offers-name'],
        'order': {
          'orderBy': 'offers-name',
          'orderDir': 'desc'
        },
        'context': 'offers',
        'totalType': {}
      },
      'campaigns': {
        'width': {
          'campaigns-name': 303
        },
        'columns': ['campaigns-name'],
        'order': {
          'orderBy': 'campaigns-name',
          'orderDir': 'desc'
        },
        'context': 'campaigns',
        'totalType': {}
      },
      'custom3': {
        'width': {
          'reports-custom3': 300
        },
        'columns': ['reports-custom3'],
        'order': {
          'orderBy': 'reports-custom3',
          'orderDir': 'desc'
        },
        'context': 'custom3',
        'totalType': {}
      },
      'referrers': {
        'width': {
          'referrers-referrer': 300
        },
        'columns': ['referrers-referrer'],
        'order': {
          'orderBy': 'referrers-referrer',
          'orderDir': 'desc'
        },
        'context': 'referrers',
        'totalType': {}
      },
      'custom7': {
        'width': {
          'reports-custom7': 300
        },
        'columns': ['reports-custom7'],
        'order': {
          'orderBy': 'reports-custom7',
          'orderDir': 'desc'
        },
        'context': 'custom7',
        'totalType': {}
      },
      'mobile-carriers': {
        'width': {
          'reports-mobilecarrier': 300
        },
        'columns': ['reports-mobilecarrier'],
        'order': {
          'orderBy': 'reports-mobilecarrier',
          'orderDir': 'desc'
        },
        'context': 'mobile-carriers',
        'totalType': {}
      },
      'custom6': {
        'width': {
          'reports-custom6': 300
        },
        'columns': ['reports-custom6'],
        'order': {
          'orderBy': 'reports-custom6',
          'orderDir': 'desc'
        },
        'context': 'custom6',
        'totalType': {}
      },
      'day-of-week': {
        'width': {
          'reports-dayofweek': 300
        },
        'columns': ['reports-dayofweek'],
        'order': {
          'orderBy': 'reports-dayofweek',
          'orderDir': 'desc'
        },
        'context': 'day-of-week',
        'totalType': {}
      },
      'states': {
        'width': {
          'reports-state': 300
        },
        'columns': ['reports-state'],
        'order': {
          'orderBy': 'reports-state',
          'orderDir': 'desc'
        },
        'context': 'states',
        'totalType': {}
      },
      'month': {
        'width': {
          'reports-month': 300
        },
        'columns': ['reports-month'],
        'order': {
          'orderBy': 'reports-month',
          'orderDir': 'desc'
        },
        'context': 'month',
        'totalType': {}
      },
      'hour-of-day': {
        'width': {
          'reports-hourofday': 300
        },
        'columns': ['reports-hourofday'],
        'order': {
          'orderBy': 'reports-hourofday',
          'orderDir': 'desc'
        },
        'context': 'hour-of-day',
        'totalType': {}
      },
      'custom9': {
        'width': {
          'reports-custom9': 300
        },
        'columns': ['reports-custom9'],
        'order': {
          'orderBy': 'reports-custom9',
          'orderDir': 'desc'
        },
        'context': 'custom9',
        'totalType': {}
      },
      'custom4': {
        'width': {
          'reports-custom4': 300
        },
        'columns': ['reports-custom4'],
        'order': {
          'orderBy': 'reports-custom4',
          'orderDir': 'desc'
        },
        'context': 'custom4',
        'totalType': {}
      },
      'traffic-sources': {
        'width': {
          'traffic_sources-name': 300
        },
        'columns': ['traffic_sources-name'],
        'order': {
          'orderBy': 'traffic_sources-name',
          'orderDir': 'desc'
        },
        'context': 'traffic-sources',
        'totalType': {}
      },
      'custom10': {
        'width': {
          'reports-custom10': 300
        },
        'columns': ['reports-custom10'],
        'order': {
          'orderBy': 'reports-custom10',
          'orderDir': 'desc'
        },
        'context': 'custom10',
        'totalType': {}
      },
      'custom1': {
        'width': {
          'reports-custom1': 300
        },
        'columns': ['reports-custom1'],
        'order': {
          'orderBy': 'reports-custom1',
          'orderDir': 'desc'
        },
        'context': 'custom1',
        'totalType': {}
      },
      'custom5': {
        'width': {
          'reports-custom5': 300
        },
        'columns': ['reports-custom5'],
        'order': {
          'orderBy': 'reports-custom5',
          'orderDir': 'desc'
        },
        'context': 'custom5',
        'totalType': {}
      },
      'flows': {
        'width': {
          'flows-name': 300
        },
        'columns': ['flows-name'],
        'order': {
          'orderBy': 'flows-name',
          'orderDir': 'desc'
        },
        'context': 'flows',
        'totalType': {}
      },
      'referrer-domains': {
        'width': {
          'referrer_domains-name': 300
        },
        'columns': ['referrer_domains-name'],
        'order': {
          'orderBy': 'referrer_domains-name',
          'orderDir': 'desc'
        },
        'context': 'referrer-domains',
        'totalType': {}
      },
      'cities': {
        'width': {
          'reports-city': 300
        },
        'columns': ['reports-city'],
        'order': {
          'orderBy': 'reports-city',
          'orderDir': 'desc'
        },
        'context': 'cities',
        'totalType': {}
      },
      'isps': {
        'width': {
          'reports-isp': 300
        },
        'columns': ['reports-isp'],
        'order': {
          'orderBy': 'reports-isp',
          'orderDir': 'desc'
        },
        'context': 'isps',
        'totalType': {}
      },
      'custom8': {
        'width': {
          'reports-custom8': 300
        },
        'columns': ['reports-custom8'],
        'order': {
          'orderBy': 'reports-custom8',
          'orderDir': 'desc'
        },
        'context': 'custom8',
        'totalType': {}
      },
      'affiliate-networks': {
        'width': {
          'affiliate_networks-name': 300
        },
        'columns': ['affiliate_networks-name'],
        'order': {
          'orderBy': 'affiliate_networks-name',
          'orderDir': 'desc'
        },
        'context': 'affiliate-networks',
        'totalType': {}
      },
      'custom2': {
        'width': {
          'reports-custom2': 300
        },
        'columns': ['reports-custom2'],
        'order': {
          'orderBy': 'reports-custom2',
          'orderDir': 'desc'
        },
        'context': 'custom2',
        'totalType': {}
      },
      'countries': {
        'width': {
          'reports-country': 300
        },
        'columns': ['reports-country'],
        'order': {
          'orderBy': 'reports-country',
          'orderDir': 'desc'
        },
        'context': 'countries',
        'totalType': {}
      },
      'day': {
        'width': {
          'reports-day': 300
        },
        'columns': ['reports-day'],
        'order': {
          'orderBy': 'reports-day',
          'orderDir': 'desc'
        },
        'context': 'day',
        'totalType': {}
      },
      'conversions': {
        'width': {
          'conversions-postbacktimestamp': 100,
          'conversions-clickid': 250
        },
        'columns': ['conversions-postbacktimestamp','conversions-clickid'],
        'order': {
          'orderBy': 'conversions-clickid',
          'orderDir': 'desc'
        },
        'context': 'conversions',
        'totalType': {}
      },
      'device-vendors': {
        'width': {
          'reports-devicevendor': 300
        },
        'columns': ['reports-devicevendor'],
        'order': {
          'orderBy': 'reports-devicevendor',
          'orderDir': 'desc'
        },
        'context': 'device-vendors',
        'totalType': {}
      },
      'live-visits': {
        'width': {
          'reports-timestamp': 100
        },
        'columns': ['reports-timestamp'],
        'order': {
          'orderBy': 'reports-timestamp',
          'orderDir': 'desc'
        },
        'context': 'live-visits',
        'totalType': {}
      },
      'languages': {
        'width': {
          'reports-language': 300
        },
        'columns': ['reports-language'],
        'order': {
          'orderBy': 'reports-language',
          'orderDir': 'desc'
        },
        'context': 'languages',
        'totalType': {}
      },
      'device-types': {
        'width': {
          'reports-devicetype': 300
        },
        'columns': ['reports-devicetype'],
        'order': {
          'orderBy': 'reports-devicetype',
          'orderDir': 'desc'
        },
        'context': 'device-types',
        'totalType': {}
      },
      'subnet-big': {
        'width': {
          'reports-subnetbig': 300
        },
        'columns': ['reports-subnetbig'],
        'order': {
          'orderBy': 'reports-subnetbig',
          'orderDir': 'desc'
        },
        'context': 'subnet-big',
        'totalType': {}
      },
      'oses': {
        'width': {
          'reports-os': 300
        },
        'columns': ['reports-os'],
        'order': {
          'orderBy': 'reports-os',
          'orderDir': 'desc'
        },
        'context': 'oses',
        'totalType': {}
      },
      'ips': {
        'width': {
          'ips-ip': 300
        },
        'columns': ['ips-ip'],
        'order': {
          'orderBy': 'ips-ip',
          'orderDir': 'desc'
        },
        'context': 'ips',
        'totalType': {}
      },
      'errors': {
        'width': {
          'errors-timestamp': 300
        },
        'columns': ['errors-timestamp'],
        'order': {
          'orderBy': 'errors-timestamp',
          'orderDir': 'desc'
        },
        'context': 'errors',
        'totalType': {}
      },
      'browsers': {
        'width': {
          'reports-browser': 300
        },
        'columns': ['reports-browser'],
        'order': {
          'orderBy': 'reports-browser',
          'orderDir': 'desc'
        },
        'context': 'browsers',
        'totalType': {}
      },
      'browser-versions': {
        'width': {
          'reports-browserversion': 300
        },
        'columns': ['reports-browserversion'],
        'order': {
          'orderBy': 'reports-browserversion',
          'orderDir': 'desc'
        },
        'context': 'browser-versions',
        'totalType': {}
      },
      'connection-types': {
        'width': {
          'reports-connecttype': 300
        },
        'columns': ['reports-connecttype'],
        'order': {
          'orderBy': 'reports-connecttype',
          'orderDir': 'desc'
        },
        'context': 'connection-types',
        'totalType': {}
      },
      'device-models': {
        'width': {
          'reports-devicemodel': 300
        },
        'columns': ['reports-devicemodel'],
        'order': {
          'orderBy': 'reports-devicemodel',
          'orderDir': 'desc'
        },
        'context': 'device-models',
        'totalType': {}
      },
      'screen-resolutions': {
        'width': {
          'reports-screenresolution': 300
        },
        'columns': ['reports-screenresolution'],
        'order': {
          'orderBy': 'reports-screenresolution',
          'orderDir': 'desc'
        },
        'context': 'screen-resolutions',
        'totalType': {}
      },
      'os-versions': {
        'width': {
          'reports-osversion': 300
        },
        'columns': ['reports-osversion'],
        'order': {
          'orderBy': 'reports-osversion',
          'orderDir': 'desc'
        },
        'context': 'os-versions',
        'totalType': {}
      },
      'postbacks': {
        'width': {
          'postbacks-timestamp': 250,
          'postbacks-clickid': 250,
          'postbacks-url': 250,
          'postbacks-status_code': 100,
          'campaigns-name': 100,
          'offers-name': 100,
          'traffic_sources-name': 100
        },
        'columns': ['postbacks-timestamp', 'postbacks-clickid', 'postbacks-url', 'postbacks-status_code', 'campaigns-name', 'offers-name', 'traffic_sources-name'],
        'order': {
          'orderBy': 'postbacks-timestamp',
          'orderDir': 'desc'
        },
        'context': 'postbacks',
        'totalType': {}
      },
      'live-clicks': {
        'width': {
          'reports-timestamp': 100
        },
        'columns': ['reports-timestamp'],
        'order': {
          'orderBy': 'reports-timestamp',
          'orderDir': 'desc'
        },
        'context': 'live-clicks',
        'totalType': {}
      },
      'subnet-small': {
        'width': {
          'reports-subnetsmall': 300
        },
        'columns': ['reports-subnetsmall'],
        'order': {
          'orderBy': 'reports-subnetsmall',
          'orderDir': 'desc'
        },
        'context': 'subnet-small',
        'totalType': {}
      },
      'useragents': {
        'width': {
          'useragents-useragent': 300
        },
        'columns': ['useragents-useragent'],
        'order': {
          'orderBy': 'reports-useragent',
          'orderDir': 'desc'
        },
        'context': 'useragents',
        'totalType': {}
      }
    };
